import type { FlowEditorNode, FlowEditorState, FlowNodeKind, WidgetTab } from "./types";
import { DonateWidget, DonateWidgetType } from "services/main/donate.service";
import { getGridConfig, getGridRows } from "./flowViewportUtils";
import { getNodeGridItem } from "./flowGridUtils";
import { isFlowNodeKind } from "./flowNodeStateUtils";
export const getFlowKindFromWidgetType = (
  type?: DonateWidgetType | string,
): FlowNodeKind => {
  if (type === "DONATION_ALERT") return "alert";
  if (type === "DONATION_GOAL") return "goal";
  if (type === "DONATION_LIST") return "leaderboard";
  return "text";
};

export const getDonateWidgetTypeFromKind = (
  kind?: FlowNodeKind | string,
): DonateWidgetType => {
  if (kind === "alert") return "DONATION_ALERT";
  if (kind === "goal") return "DONATION_GOAL";
  if (kind === "leaderboard") return "DONATION_LIST";
  return "CUSTOM";
};

export const getFlowKindFromGridItem = (item: any): FlowNodeKind => {
  if (isFlowNodeKind(item?.data?.kind)) return item.data.kind;
  if (isFlowNodeKind(item?.type)) return item.type;
  return getFlowKindFromWidgetType(item?.type);
};

export const findWidgetGridItemByTab = (
  widget: DonateWidget | undefined,
  tab: WidgetTab,
) => {
  const items = widget?.gridLayout?.items || [];
  const visibleItems = items.filter((item) => item?.isVisible !== false);
  const candidates = visibleItems.length ? visibleItems : items;

  return (
    candidates.find((item) => getFlowKindFromGridItem(item) === tab) ||
    candidates[0]
  );
};

export const getWidgetSettings = (
  widget: DonateWidget | undefined,
  tab: WidgetTab,
) => ({
  ...(widget?.settings || {}),
  ...(findWidgetGridItemByTab(widget, tab)?.settings || {}),
});

export const getWidgetStyles = (widget: DonateWidget | undefined, tab: WidgetTab) => ({
  ...(widget?.styles || {}),
  ...(findWidgetGridItemByTab(widget, tab)?.styles || {}),
});

export const getGridLayoutItemId = (item: any, index: number) =>
  String(item?.id || item?.i || `node-${index + 1}`);

export const getFrontendPlacement = (item: any) =>
  item?.settings?.frontendPlacement ||
  item?.data?.frontendPlacement ||
  item?.settings?.placement ||
  item?.data?.placement;

export const buildFrontendPlacement = (
  node: FlowEditorNode,
  viewport: FlowEditorState["viewport"],
) => {
  const item = getNodeGridItem(node, viewport);
  const config = getGridConfig(viewport);

  return {
    x: item.x,
    y: item.y,
    w: item.w,
    h: item.h,
    cols: config.cols,
    rows: getGridRows(viewport),
    device: viewport.device,
  };
};
